import data from "../../../../../src/Popover/Popover.docs.json";
import * as React from 'react';
export default {
  data,
  React
};